<app-dropdown-menu #dropdownMenuThemes [productLines]="THEMES">
</app-dropdown-menu>
<app-dropdown-menu #dropdownMenuTheme
                   [sections]="settingsSections"
                   [minimumColumns]="2"
                   (itemSelect)="onSettingSelect($event)">
</app-dropdown-menu>
<nav class="bottom-nav">
  <!-- Back, on every page after the first. -->
  <a role="button" (click)="prevPage()" *ngIf="page > 0">
    <app-icon name="chevron-left" fixedWidth aria-hidden="true"></app-icon>
    <span> Back </span>
  </a>

  <!-- The page's items: at most 5 buttons ever share the bar. -->
  <ng-container *ngFor="let item of pageItems">
    <a *ngIf="item.link" [routerLink]="item.link"
       [attr.aria-label]="item.badge === 'cart' && cartCount > 0 ? item.label + ', ' + cartCount + ' item' + (cartCount === 1 ? '' : 's') : null">
      <!-- The cart item carries its count as a badge on the icon's corner. -->
      <span class="icon-with-badge">
        <app-icon [name]="item.icon" fixedWidth aria-hidden="true"></app-icon>
        <span class="icon-badge" *ngIf="item.badge === 'cart' && cartCount > 0" aria-hidden="true">{{ cartCount }}</span>
      </span>
      <span> {{ item.label }} </span>
    </a>
    <a role="button"
       *ngIf="item.action === 'appearance'"
       (click)="dropdownMenuTheme.toggle($event)">
      <div class="indicator" *ngIf="dropdownMenuTheme.isDropdownOpen"></div>
      <app-icon [name]="item.icon" fixedWidth aria-hidden="true"></app-icon>
      <span> {{ item.label }} </span>
    </a>
  </ng-container>

  <!-- Fillers keep the last page's buttons the same width as every page. -->
  <a class="nav-filler" aria-hidden="true" *ngFor="let filler of fillerSlots"></a>

  <!-- More, whenever items overflow into a next page. -->
  <a role="button" (click)="nextPage()" *ngIf="hasNextPage">
    <app-icon name="chevron-right" fixedWidth aria-hidden="true"></app-icon>
    <span> More </span>
  </a>
</nav>
